import { useEffect, useRef, useState } from 'react';
import { DatePicker } from 'rsuite';
import { Box, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { ExpandLess, ExpandMore, MoreVert } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import {
  toggleAxesEdited,
  updateAxesQueryParam,
} from '../../../redux/ChartPoperties/ChartPropertiesActions';
import { useDispatch } from 'react-redux';
import {
  setParameterData,
  setParameterIntoFilters,
} from '../../../redux/Parameters/ParametersAction';
import { chartFilterGroupEdited } from '../../../redux/ChartFilterGroup/ChartFilterGroupStateActions';
import { updateCalculation } from '../../../redux/Calculations/CalculationsActions';
import { ICurrentCalculationSession } from '../../../redux/Calculations/CurrentCalculationSessionInterface';
import { RootState } from '../../../redux';
import { ParameterProps } from '../ParameterContainer';
import { fontSize } from '../../..';
import { callQueryAPI } from '../../../redux/ChartPoperties/ChartControlsActions';
import { callQueryAPIDashboard } from '../../../redux/TabTile/TabTileActionsAndMultipleDispatches';
import { AxisType } from '../../CommonFunctions/aliases';

const Calendar = ({
  parameter,
  handleEditParameter,
  propKey,
  editMode,
  showDash,
  color,
  backgroundColor,
}: ParameterProps) => {
  const { chartProperties, calculations, parameters } = useSelector((state: RootState) => {
    return {
      chartProperties: state.chartProperties,
      calculations: state.calculations,
      parameters: state.parameters,
    };
  });

  const dispatch = useDispatch();

  const [value, setValue] = useState<Date>(() => {
    return parameter.userSelection
      ? new Date(parameter.userSelection)
      : parameter.columns.defaultValue
        ? new Date(parameter.columns.defaultValue as string)
        : new Date(parameter.minValue);
  });
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [expanded, setExpanded] = useState(true);

  const currentChartAxesRef = useRef<any[]>([]);
  const currentChatFieldRef = useRef<any>(null);
  const currentChartAxesNameRef = useRef<any>(null);
  const itemIndexRef = useRef<any>(null);
  const isFirstRender = useRef(true);

  const currentChartField = chartProperties.properties[propKey]?.chartAxes[0]?.fields?.find(
    (field: any) => field.parameterId === parameter.parameterId,
  );

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const callQueryAPIFilter = () => {
    let callAPIDashboard = false;
    chartProperties.propList[1].forEach((tabTileId: string) => {
      chartProperties.properties[tabTileId].chartAxes[0].fields.some((field: any) => {
        if (field.parameterId === parameter.parameterId) {
          dispatch(callQueryAPI(tabTileId, true));
          callAPIDashboard = true;
        }
      });
      let measureAxes = chartProperties.properties[tabTileId].chartAxes.filter((axis: any) =>
        [AxisType.Measure, AxisType.X, AxisType.Y].includes(axis.name),
      );
      measureAxes.forEach((axes: any) => {
        axes.fields.some((field: any) => {
          if (field.override) {
            field.override[0].fields.some((FilterField: any) => {
              if (FilterField.parameterId === parameter.parameterId) {
                dispatch(callQueryAPI(tabTileId, true));
                callAPIDashboard = true;
              }
            });
          }
        });
      });
    });
    if (showDash && callAPIDashboard) {
      dispatch(callQueryAPIDashboard(true));
    }
  };

  const updateUserFilterItem = (
    propKey: string,
    bIndex: number,
    itemIndex: number,
    field: any,
    axesName: string,
  ) => {
    dispatch(updateAxesQueryParam(propKey, bIndex, itemIndex, field, axesName));
  };

  const callAPI = (uid: string | undefined) => {
    let callAPIDashboard = false;
    Object.entries(chartProperties.properties).forEach(([tabTileId, prop]: [string, any]) => {
      prop.chartAxes?.forEach((axis: any) => {
        axis.fields?.forEach((field: any) => {
          if (field.SavedCalculationUUID === uid) {
            dispatch(callQueryAPI(tabTileId, true));
            callAPIDashboard = true;
          }
        });
      });
    });
    if (showDash && callAPIDashboard) {
      dispatch(callQueryAPIDashboard(true));
    }
  };

  const handleChangeDate = (date: Date) => {
    // Format the date to 'yyyy-mm-dd'
    const formattedDate = date.toISOString().slice(0, 10);
    setValue(date);

    dispatch(setParameterData(parameter.parameterId, formattedDate));
    // if (currentChatFieldRef.current && currentChatFieldRef.current.isParameterized) {
    //   if (currentChatFieldRef.current.fieldtypeoption === 'Pick List') {
    //     currentChatFieldRef.current.userSelection = [formattedDate];
    //   } else currentChatFieldRef.current.exprInput = formattedDate;

    //   updateUserFilterItem(
    //     propKey,
    //     0,
    //     itemIndexRef.current,
    //     currentChatFieldRef.current,
    //     currentChartAxesNameRef.current,
    //   );
    // }
    Array.isArray(parameter.chartFilter) &&
      parameter.chartFilter.forEach((cf: any) => {
        if (!cf.currentChartAxesName?.includes('chartAxes_')) {
          if (cf.propKey) {
            const clonedField = {
              ...chartProperties.properties[cf.propKey].chartAxes[0].fields[cf.itemIndex],
            };
            if (clonedField.fieldtypeoption === 'Pick List') {
              clonedField.userSelection = [formattedDate];
            } else clonedField.exprInput = formattedDate;
            updateUserFilterItem(cf.propKey, 0, cf.itemIndex, clonedField, cf.currentChartAxesName);
          } else if (cf.itemIndex >= 0 && cf.currentChartAxesName) {
            chartProperties.propList[1].forEach((tabTileId: string) => {
              chartProperties.properties[tabTileId].chartAxes[0].fields.some((field: any) => {
                if (field.parameterId === parameter.parameterId) {
                  dispatch(
                    setParameterIntoFilters(
                      tabTileId,
                      parameter.parameterId,
                      field.uId,
                      cf.itemIndex,
                      cf.currentChartAxesName,
                    ),
                  );

                  const clonedField = {
                    ...chartProperties.properties[tabTileId].chartAxes[0].fields[cf.itemIndex],
                  };
                  if (clonedField.fieldtypeoption === 'Pick List') {
                    clonedField.userSelection = [formattedDate];
                  } else clonedField.exprInput = formattedDate;
                  updateUserFilterItem(
                    tabTileId,
                    0,
                    cf.itemIndex,
                    clonedField,
                    cf.currentChartAxesName,
                  );
                }
              });
            });
          }
        }
      }),
      callQueryAPIFilter();

    if (parameter.calculationId.length > 0) {
      const targetCalculation = calculations.savedCalculations.filter(
        (cal: any) => cal.uuid === parameter.calculationId.find((id: any) => id === cal.uuid),
      );

      targetCalculation.map((calculation: ICurrentCalculationSession) => {
        const targetFlowNames = Object.keys(calculation.calculationInfo.flows);
        targetFlowNames.map((flowName: any) => {
          const targetFlow = calculation.calculationInfo.flows[flowName][0];
          const conditionFilters = calculation.calculationInfo.conditionFilters;
          if (targetFlow.flow === 'IfElse') {
            for (const conditionFilter in conditionFilters) {
              let newConditions = conditionFilters[conditionFilter][0];
              newConditions.conditions.forEach((filter: any) => {
                if (filter.parameterId.length > 0) {
                  filter.parameterId.map((parameterId: string, index: number) => {
                    if (parameterId === parameter.parameterId) {
                      filter.rightOperand[index] = formattedDate;
                    }
                  });
                }
              });
            }
            dispatch(toggleAxesEdited(propKey, true));
            dispatch(chartFilterGroupEdited(true));
            dispatch(updateCalculation(calculation));
            callAPI(calculation.uuid);
          }
        });
      });
    }

    // filter_override?.forEach((parameter: any) => {
    parameter?.chartFilter?.forEach((filter: any) => {
      if (filter?.currentChartAxesName?.includes('chartAxes_')) {
        const currentChartAxesName_ = filter?.currentChartAxesName.split('_')[1];
        if (filter.propKey) {
          const chartAxes = chartProperties.properties[filter.propKey]?.chartAxes;
          const chartFilter = chartAxes[chartAxes.length - 1].fields;
          chartFilter?.forEach((field: any, index: number) => {
            if (currentChartAxesName_ === field.enableOverrideForUID) {
              return;
            }
            if (field.uId === currentChartAxesName_) {
              const override_ = field.override;
              if (Array.isArray(override_) && override_.length > 0) {
                override_[0].fields.forEach((field_: any, index_: number) => {
                  if (field_.uId === filter.chartFilterId) {
                    if (field_.fieldtypeoption === 'Pick List') {
                      field_.userSelection = [formattedDate];
                    } else field_.exprInput = formattedDate;

                    field.override = override_;
                    updateUserFilterItem(
                      filter.propKey,
                      chartAxes.length - 1,
                      index,
                      field,
                      'chartAxes',
                    );
                    callQueryAPIFilter();
                  }
                });
              }
            }
          });
        } else {
        }
      }
    });
    // });
  };

  useEffect(() => {
    currentChartAxesRef.current = chartProperties.properties[propKey]?.chartAxes[0]?.fields || [];

    // Find the field where any chartFilter in parameter.chartFilter matches filter.uId
    currentChatFieldRef.current = currentChartAxesRef.current.find(
      (filter: any) =>
        Array.isArray(parameter.chartFilter) &&
        parameter.chartFilter.some((cf: any) => {
          if (cf.chartFilterId === filter.uId) {
            currentChartAxesNameRef.current = cf.currentChartAxesName;
            itemIndexRef.current = cf.itemIndex;
            return cf.chartFilterId === filter.uId;
          }
        }),
    );
  }, [chartProperties.properties[propKey]?.chartAxes[0]?.fields, parameter.chartFilter, propKey]);

  // if the parameter had any default value then it will update the Graph
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const formattedDate = value?.toISOString().slice(0, 10);
    if (currentChatFieldRef.current && currentChatFieldRef.current.isParameterized && value) {
      if (currentChatFieldRef.current.fieldtypeoption === 'Pick List') {
        currentChatFieldRef.current.userSelection = [formattedDate];
      } else currentChatFieldRef.current.exprInput = formattedDate;

      updateUserFilterItem(
        propKey,
        0,
        itemIndexRef.current,
        currentChatFieldRef.current,
        currentChartAxesNameRef.current,
      );
      callQueryAPIFilter();
    }

    if (parameter.calculationId.length > 0) {
      const targetCalculation = calculations.savedCalculations.filter(
        (cal: any) => cal.uuid === parameter.calculationId.find((id: any) => id === cal.uuid),
      );

      targetCalculation.map((calculation: ICurrentCalculationSession) => {
        const targetFlowNames = Object.keys(calculation.calculationInfo.flows);
        targetFlowNames.map((flowName: any) => {
          const targetFlow = calculation.calculationInfo.flows[flowName][0];
          const conditionFilters = calculation.calculationInfo.conditionFilters;
          if (targetFlow.flow === 'IfElse') {
            for (const conditionFilter in conditionFilters) {
              let newConditions = conditionFilters[conditionFilter][0];
              newConditions.conditions.forEach((filter: any) => {
                if (filter.parameterId.length > 0) {
                  filter.parameterId.map((parameterId: string, index: number) => {
                    if (parameterId === parameter.parameterId) {
                      filter.rightOperand[index] = formattedDate;
                    }
                  });
                }
              });
            }
            dispatch(toggleAxesEdited(propKey, true));
            dispatch(chartFilterGroupEdited(true));
            dispatch(updateCalculation(calculation));
          }
        });
      });
    }

    // filter_override?.forEach((parameter: any) => {
    parameter?.chartFilter?.forEach((filter: any) => {
      if (filter?.currentChartAxesName?.includes('chartAxes_')) {
        const currentChartAxesName_ = filter?.currentChartAxesName.split('_')[1];
        const chartAxes = chartProperties.properties[propKey]?.chartAxes;
        const chartFilter = chartAxes[chartAxes.length - 1].fields;
        chartFilter?.forEach((field: any, index: number) => {
          if (currentChartAxesName_ === field.enableOverrideForUID) {
            return;
          }
          if (field.uId === currentChartAxesName_) {
            const override_ = field.override;
            if (Array.isArray(override_) && override_.length > 0) {
              override_[0].fields.forEach((field_: any, index_: number) => {
                if (field_.uId === filter.chartFilterId) {
                  if (field_.fieldtypeoption === 'Pick List') {
                    field_.userSelection = [formattedDate];
                  } else field_.exprInput = formattedDate;

                  field.override = override_;
                  updateUserFilterItem(propKey, chartAxes.length - 1, index, field, 'chartAxes');
                  callQueryAPIFilter();
                }
              });
            }
          }
        });
      }
    });
    // });
  }, [
    parameter.chartFilter,
    // currentChatFieldRef.current,
    // propKey,
    // currentChartField?.parameterId
  ]);

  return (
    <Box sx={{ width: '100%', position: 'relative' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: backgroundColor,
        }}
      >
        <Box>
          <Typography
            variant="body2"
            sx={{
              mb: 0.5,
              fontWeight: 500,
              transform: 'capitalize',
              color: color,
              textAlign: 'start',
            }}
          >
            {parameter?.name}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: -1,
            transition: 'all 0.3s ease-in-out',
          }}
        >
          {editMode && (
            <IconButton
              size="small"
              id="basic-button"
              aria-controls={Boolean(anchorEl) ? 'basic-menu' : undefined}
              sx={{ color: color }}
              onClick={handleClick}
            >
              <MoreVert />
            </IconButton>
          )}
          <IconButton
            size="small"
            sx={{
              mr: '0.4rem',
              color: color,
            }}
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </Box>
      </Box>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem dense onClick={() => handleEditParameter(parameter.parameterId)}>
          Remove
        </MenuItem>
      </Menu>

      <Box sx={{ width: '100%', position: 'relative' }}>
        <style>
          {`

          .custom-calendar .rs-input-group.rs-input-group-inside {
        background: ${backgroundColor} !important;
      }

       .custom-calendar .rs-input-group-sm.rs-input-group > .rs-input-group-addon > .rs-icon {
      color: ${color} ;   
    }
      .custom-calendar .rs-input {
        color: ${color} ;
        background: ${backgroundColor} !important;
       
      }
        .rs-input-group{
          border-color: ${color} !important;
        }
         .custom-calendar .rs-input:focus,
    .custom-calendar .rs-input:hover,
    .custom-calendar .rs-input-group.rs-input-group-inside:hover,
    .custom-calendar .rs-input-group.rs-input-group-inside:focus {
      border-color: ${color} !important;
      box-shadow: none !important;
    }
      .custom-calendar .rs-picker-toggle-caret,
      .custom-calendar .rs-picker-caret-icon,
      
       {
        color: ${color} ;
      }
    `}
        </style>

        {expanded && (
          <DatePicker
            size="sm"
            placeholder="Select a date"
            className="custom-calendar"
            style={{ width: '97%' }}
            container={() => document.querySelector('.MuiDialog-root')!}
            placement="leftStart"
            menuStyle={{ zIndex: 9999 }}
            defaultValue={value as Date}
            onChange={(date) => handleChangeDate(date!)}
            cleanable={false}
          />
        )}
      </Box>
    </Box>
  );
};

export default Calendar;
